import { CustomIcon } from '../models/icon';

export const PargoArrow: CustomIcon = {
  path: 'assets/images/toolbar-icons/PargoArrow.svg',
  name: 'pargo-arrow-pargo',
};

export const CTA_ICONS: CustomIcon[] = [PargoArrow];
